import {FC, PropsWithChildren} from "react";

export enum BadgeStyle {
  default = 'default',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
}

export const Badge: FC<PropsWithChildren<{style?: BadgeStyle}>> = ({style, children}) => {
  const badgeClass = {
    [BadgeStyle.default]: 'bg-slate-100 text-slate-700',
    [BadgeStyle.success]: 'bg-green-100 text-green-700',
    [BadgeStyle.info]: 'bg-blue-100 text-blue-700',
    [BadgeStyle.warning]: 'bg-yellow-100 text-yellow-700',
    [BadgeStyle.danger]: 'bg-red-100 text-red-700',
  }[style ?? BadgeStyle.default]

  return (
    <div className={`inline-flex items-center justify-center px-2 py-0.5 my-0.5 rounded-full text-xs uppercase font-semibold ${badgeClass}`}>
      {children}
    </div>
  );
}
